<template>
  <div class="coin-stock-header-wrapper contents">
    <div class="contents new-style">
      <!-- 极简原生 Header：完全移除外部 style 依赖，使用 UnoCSS + 主题 Token -->
      <header
        class="fixed top-0 left-0 w-full h-64px px-20px z-1000
               flex items-center justify-between
               bg-16151A
               backdrop-blur-12px"
      >
        <div class="flex-1 min-w-0 h-full flex items-center overflow-hidden">
          <!-- Logo 区域 -->
          <Link to="/" class="cursor-pointer flex items-center shrink-0">
            <img
              v-inmodule="['/home']"
              alt="BiFinance"
              class="w-110px h-24px mr-20px shrink-0"
              src="@/image/home/logo-dark.webp"
            >
          </Link>

          <!-- 导航菜单 -->
          <nav class="coin-stock-nav flex-1 min-w-0 flex items-center h-full ml-10px overflow-x-auto overflow-y-hidden">
            <Row
              v-for="item in navList"
              :key="item.key"
              class="relative h-full flex items-center cursor-pointer shrink-0"
              :style="header_icon_gap"
              y="c"
              @click="!item.children?.length && selectMenu(item.key)"
            >
              <HoverDropdownMenu
                v-if="item.children?.length"
                :items="item.children"
                popper-class="coin-stock-header-dropdown"
                @select="selectMenu"
              >
                <Row
                  class="text-14px transition-colors duration-300 text-white font-normal header-hover-bg outline-none"
                  y="c"
                >
                  <span>{{ item.label }}</span>
                  <MenuArrowsDown class="ml-6px text-white" />
                </Row>
              </HoverDropdownMenu>
              <Row
                v-else
                class="text-14px transition-colors duration-300 text-white font-normal header-hover-bg shrink-0 whitespace-nowrap"
                y="c"
              >
                <img
                  v-if="item.iconImg"
                  :src="item.iconImg"
                  class="w-20 h-20 mr-4px shrink-0"
                  alt="icon"
                >
                <span v-else-if="item.icon" class="text-16px mr-4px shrink-0 whitespace-nowrap">{{ item.icon }}</span>
                <span class="shrink-0 whitespace-nowrap">{{ item.label }}</span>
                <span
                  v-if="item.badge"
                  class="text-10px uppercase font-semibold ml-6px px-6px py-1px rounded-full shrink-0 whitespace-nowrap"
                  style="background-color:#06F0C6;color:#16151A;border-radius:4px"
                >
                  {{ item.badge }}
                </span>
              </Row>
            </Row>
          </nav>
        </div>

        <!-- 右侧菜单 -->
        <div class="flex items-center shrink-0">
          <rightMenu :isSmallScreen="isSmallScreen" gap="0" />
        </div>
      </header>

      <!-- 固钉占位 -->
      <div class="w-full h-64px" />
    </div>
  </div>
</template>

<script setup>
import rightMenu from './rightMenu/index.vue'
import QuerySymbol from './QuerySymbol.vue'
import { getBusinessPath } from '@/utils/localeRoute.js'
import hotIcon from '@/image/user/hot.gif'
import MenuArrowsDown from './MenuArrowsDown.vue'

import { THEME_DARK } from '@/hook/useAppColorMode.js'

const configStore = useConfigStore()
const route = useRoute()
const businessPath = $computed(() => getBusinessPath(route.path))

const navList = $computed(() => [
  { label: $t('stock.stockIntroduce'), key: 'coinStock' },
  {
    label: $t('stock.stockTab'),
    key: 'stockToken',
    children: [
      { label: $t('stock.spotTrading'), key: 'coinStockTrade' },
      { label: $t('stock.quickConvert'), key: 'coinStockConvert', badge: $t('stock.quickConvertTag') },
    ],
  },
  { label: $t('stock.stockContractTab'), key: 'stockFutures' },
  { label: $t('stock.stockIpoNav'), key: 'ipo', iconImg: hotIcon },
  { label: $t('stock.bifundNav'), key: 'bifund', badge: $t('stock.bifundTag') },
])

const menuConfig = {
  coinStock: { path: '/coinStock' },
  coinStockTrade: { path: '/coinStockTrade' },
  coinStockConvert: { path: '/coinStockConvert' },
  stockFutures: { path: '/coinStockFutures' },
  ipo: { path: '/ipo' },
  bifund: { path: '/bffund' },
}

const selectMenu = (key) => {
  const config = menuConfig[key]
  if (!config || !config.path) return

  const path = typeof config.path === 'function' ? config.path() : config.path

  if (config.requireLogin) {
    toRouter(path, { requireLogin: true, redirect: path })
  } else {
    toRouter(path)
  }
}

let letfIconGap = $ref(8)
let isSmallScreen = $ref(window.innerWidth <= 1590)

onBeforeMount(() => {
  eventBus.on('onResize', e => {
    isSmallScreen = window.innerWidth <= 1590
    if (window.innerWidth > 1440) {
      letfIconGap = 8
    } else {
      letfIconGap = 4
    }
  })
})

const header_icon_gap = $computed(() => {
  return { 'margin-right': `${letfIconGap}px` }
})

</script>

<style lang="scss" scoped>
/* 整个组件已实现零 CSS 代码，全部逻辑与样式已移至 HTML 模板 */
.header-hover-bg {
    display: inline-flex;
    border-radius: 999px;
    min-height: 32px;
    padding: 0 12px;
    transition: background-color 0.2s ease;
    white-space: nowrap;
    word-break: keep-all !important;
    &:hover {
      background-color: #2C2C2C;
    }

    * {
      white-space: nowrap;
      word-break: keep-all !important;
    }
}

.coin-stock-nav {
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
}

:global(.coin-stock-header-dropdown) {
  --el-dropdown-menuItem-hover-color: var(--el-text-color-regular);
}

</style>
